export default {
  name: "Tiger",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/logo-color.webp`,
  products: [
    {
      id: "lager",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/en/product_forward_tiger.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/fr/product_forward_tiger.webp`,
      },
      name: {
        en: "Lager",
        fr: "Lager",
      },
      description: {
        en: "Born in Singapore and made for the heat of the streets. Our goal: to inspire courage because every man has a Tiger inside.",
        fr: "Née à Singapour et conçue pour la chaleur des rues. Notre objectif : inspirer le courage, car chaque homme a un tigre en lui.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/en/information_render_can_500ml_tiger.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/fr/information_render_can_500ml_tiger.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/en/information_nft_can_500ml_tiger.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/tiger/fr/information_nft_can_500ml_tiger_fr.webp`,
          },
          name: {
            en: "Can 500ml",
            fr: "Canette 500ml",
          },
        },
      ],
    },
  ],
};
